import React, { Component } from "react";
import { css } from "glamor";
import * as styles from "./../disclaimer/termofuse.style";
import Modal from "react-modal";
import * as translate from "../../assets/translations/translations";
import Danske_Bank_privacy_notice from "../../assets/pdf/Danske_Bank_privacy_notice.pdf";
import Cookies from "universal-cookie";

const bannerCustomStyles = {
  backgroundColor: "#003755",
  color: "#fff",
  padding: "10px",
  fontSize: ".875em",
};

const customStyles = {
  content: {
    top: "20%",
    // left: '50%',
    // right: 'auto',
    bottom: "auto",
    // marginRight: '-50%',
    // transform: 'translate(-50%, -50%)',
    backgroundColor: "#e7f1f7f7",
  },
};

const CookiesAcceptedKey = "cookies-accepted"; // used in index.html adobeAnalytics function.
const CookiesNecessaryAcceptedKey = "necessary-cookies";

export default class CookieDescriptionPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cookieBtnText: translate.strings.cookieconsent.newCookieBannerBtn1,
    };
    this.closeCookieDescPopup = this.closeCookieDescPopup.bind(this);
    this.onAcceptCookies = this.onAcceptCookies.bind(this);
    this.onNecessaryAcceptCookies = this.onNecessaryAcceptCookies.bind(this);
    Modal.setAppElement("#root");
  }

  closeCookieDescPopup(status) {
    this.props.setCookiePolicyDescriptionModalIsOpen(status);
  }

  handleCheckboxSelections(e) {
    if (e.target.checked) {
      this.setState({
        cookieBtnText: translate.strings.cookieconsent.newCookieBannerBtn2,
      });
    } else {
      this.setState({
        cookieBtnText: translate.strings.cookieconsent.newCookieBannerBtn1,
      });
    }
  }

  onAcceptCookies() {
    const cookies = new Cookies();
    const expiresInDays = 180;
    let d = new Date();
    d.setTime(d.getTime() + expiresInDays * 24 * 60 * 60 * 1000);
    cookies.set(CookiesAcceptedKey, "true", { path: "/", expires: d });

    window.adobeAnalytics();
    this.closeCookieDescPopup(false);
  }

  onNecessaryAcceptCookies() {
    const cookies = new Cookies();
    const expiresInDays = 180;
    let d = new Date();
    if (this.state.cookieBtnText == "Ok to selected") {
      d.setTime(d.getTime() + expiresInDays * 24 * 60 * 60 * 1000);
      cookies.set(CookiesAcceptedKey, "true", { path: "/", expires: d });
      window.adobeAnalytics();
    } else {
      d.setTime(d.getTime() + expiresInDays * 24 * 60 * 60 * 1000);
      cookies.set(CookiesNecessaryAcceptedKey, "true", {
        path: "/",
        expires: d,
      });
    }
    this.closeCookieDescPopup(false);
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.CookiePolicyDescriptionModalIsOpen}
          // onRequestClose={this.closeCookieDescription}
          contentLabel="Terms of use of website "
          shouldCloseOnOverlayClick={true}
          overlayClassName="Overlay"
          className="Modal TermsOfUseModal"
          tabindex="-1"
          style={customStyles}
        >
          <div style={{ zIndex: "9999", position: "relative" }}>
            <div>
              <div
                style={{ backgroundColor: "#e1edf3", color: "#003755" }}
                {...css(bannerCustomStyles)}
                className="row"
                aria-hidden="true"
              >
                <div className="col-s-12 col-md-12 col-lg-12">
                  {/* <p>{translate.strings.cookieconsent.bannerText}</p> */}
                  <p style={{ fontSize: "18px", fontWeight: "800" }}>
                    {translate.strings.cookieconsent.newCookieBannerHeading}
                  </p>
                  <p style={{ marginTop: "10px", lineHeight: "1.5" }}>
                    {translate.strings.cookieconsent.newCookieBannerTextP1}
                    &nbsp;
                    <a
                      href="/research/cookie-policy"
                      target="_blank"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      <u>
                        {translate.strings.cookieconsent.newCookieBannerTextP2}
                      </u>
                    </a>
                    &nbsp;
                    {translate.strings.cookieconsent.newCookieBannerTextP3}
                    &nbsp;
                    <a
                      href={Danske_Bank_privacy_notice}
                      target="_blank"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      <u>
                        {translate.strings.cookieconsent.newCookieBannerTextP4}
                      </u>
                    </a>
                    {translate.strings.cookieconsent.newCookieBannerTextP5}
                  </p>
                  &nbsp;
                  {/* <p>
                                                    <a href="#" tabindex="-1" onClick={() => this.onRejectCookies()} style={{ color: "#FFFFFF" }}>{translate.strings.cookieconsent.rejectText}</a>
                                                    &nbsp;
                                                    <a href="#" tabindex="-1" onClick={() => this.handleShowAboutCookies()} style={{ color: "#FFFFFF" }}>
                                                        <span  {...css(readAboutCls)}>{translate.strings.cookieconsent.readMoreText}</span>
                                                    </a>
                                                    {this.state.showAboutCookies === true ? this.renderAboutCookies() : null}
                                                </p> */}
                  <p
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      lineHeight: "1.5",
                    }}
                  >
                    <p style={{ display: "flex", alignItems: "center" }}>
                      <input
                        id="ness_cookie"
                        type="checkbox"
                        checked={true}
                        disabled={true}
                        style={{
                          zoom: "2",
                          marginRight: "5px",
                          cursor: "pointer",
                        }}
                      />
                      <label
                        for="ness_cookie"
                        style={{
                          fontSize: "16px",
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        {
                          translate.strings.cookieconsent
                            .newCookieBannerChkBoxHeading1
                        }
                      </label>
                    </p>
                    <p style={{ marginLeft: "36px" }}>
                      {
                        translate.strings.cookieconsent
                          .newCookieBannerChkBoxText1
                      }
                    </p>
                  </p>
                  <p style={{ lineHeight: "1.5" }}>
                    <p style={{ display: "flex", alignItems: "center" }}>
                      <input
                        id="statis_cookie"
                        type="checkbox"
                        onChange={(e) => {
                          this.handleCheckboxSelections(e);
                        }}
                        style={{
                          zoom: "2",
                          marginRight: "5px",
                          borderRadius: "0px",
                          cursor: "pointer",
                        }}
                      />
                      <label
                        for="statis_cookie"
                        style={{
                          fontSize: "16px",
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        {
                          translate.strings.cookieconsent
                            .newCookieBannerChkBoxHeading2
                        }
                      </label>
                    </p>
                    <p style={{ marginLeft: "36px" }}>
                      {
                        translate.strings.cookieconsent
                          .newCookieBannerChkBoxText2
                      }
                    </p>
                  </p>
                  <div style={{ marginTop: "20px" }}>
                    <button
                      type="button"
                      className="btn"
                      style={{
                        borderRadius: 40,
                        backgroundColor: "#f0f7fa",
                        color: "#002337",
                        border: "1px solid #00233733",
                        cursor: "pointer",
                        minWidth: "185px",
                        minHeight: "45px",
                      }}
                      onClick={() => {
                        this.onNecessaryAcceptCookies();
                      }}
                    >
                      {this.state.cookieBtnText}
                    </button>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn"
                      style={{
                        borderRadius: 40,
                        backgroundColor: "#007BC7",
                        color: "white",
                        cursor: "pointer",
                        minWidth: "185px",
                        minHeight: "45px",
                      }}
                      onClick={() => {
                        this.onAcceptCookies();
                      }}
                    >
                      {translate.strings.cookieconsent.newCookieBannerBtn3}
                    </button>
                  </div>
                </div>
                {/* <div className="col-s-12 col-md-2">
                                                <button tabindex="-1" className="btn-block btn-danske btn mt-3 mt-md-0" style={{ background: '#FFFFFF', borderColor: '#FFFFFF', color: '#003755' }} onClick={() => { this.onAcceptCookies(); }}>{translate.strings.cookieconsent.acceptText}</button>
                                            </div> */}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
